import NumberFormat from "react-number-format"
import { FC } from "react"
import { FORMAT_PHONE, getPhoneWithOutCode } from "../../../validations/phone"
import { Link } from "../../ui/Link"
import { LinkVariants } from "../../ui/Link/constants"

const Phone: FC<{
  phone?: string
}> = ({ phone }) => {
  return (
    <>
      {!!phone && (
        <Link href={`tel:${phone}`} variant={LinkVariants.BLACK_TO_PURPLE}>
          <NumberFormat
            format={FORMAT_PHONE}
            mask={"_"}
            value={getPhoneWithOutCode(phone || "")}
            displayType={"text"}
          />
        </Link>
      )}
    </>
  )
}

export { Phone }
